import { Calendar } from 'owa-calendar-cache';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';

/**
 * Inserts calendar into selected calendars in order of calendars collection
 */
export function insertCalendar(calendar: Calendar, target: Calendar[], calendars: Calendar[]) {
    if (target.length > 0) {
        let foundCalendarResult = findInArray(calendars, item => {
            return item.id.id == calendar.id.id;
        });
        let calendarPosition = foundCalendarResult ? foundCalendarResult.index : 0;
        let cache: { [id: string]: Calendar } = {};

        // build dictionary of calendars standing before calendar being selected.
        for (--calendarPosition; calendarPosition >= 0; calendarPosition--) {
            let calendar = calendars[calendarPosition];
            cache[calendar.id.id] = calendar;
        }

        // insert at position of first calendar not in dictionary of 'before-me' calendars
        for (let i = 0; i < target.length; i++) {
            if (!cache[target[i].id.id]) {
                target.splice(i, 0, calendar);
                return;
            }
        }
    }

    target.push(calendar);
}
